import { getTranslatedMessages } from './translates';

$('.login-form').validate({
    rules: {
        email: {
            required: true,
            email: true,
        },
        password: {
            required: true,
        },
    },
    messages: getTranslatedMessages(),
});
